import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-5 py-10" }
const _hoisted_2 = {
  key: 0,
  class: "flex w-full justify-center gap-1"
}
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "px-1 py-2 w-[57px] text-2xl text-white font-bold rounded-lg leading-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-white text-sm pt-1" }, "Days", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h1", { class: "leading-10 text-white text-2xl font-bold py-2 px-1" }, ":", -1)
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "px-1 py-2 w-[57px] text-center text-2xl leading-10 text-white font-bold rounded-lg" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-white text-sm pt-1" }, "Hours", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", { class: "leading-10 text-white text-2xl font-bold py-2 px-1" }, ":", -1)
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = { class: "px-1 py-2 w-[57px] text-center text-2xl leading-10 text-white font-bold rounded-lg" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "text-center text-white text-sm pt-1" }, "Minutes", -1)
const _hoisted_14 = {
  key: 1,
  class: "font-black text-3xl text-white text-center"
}
const _hoisted_15 = { class: "text-white text-center px-16" }
const _hoisted_16 = { class: "flex flex-col justify-center pt-3 gap-5 px-14" }

interface Props {
    data: object
    withTimer?: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'BannerTemplate',
  props: {
    data: null,
    withTimer: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    data: object
    withTimer?: boolean
  }

  

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "py-8 bg-cover bg-center bg-no-repeat mb-10 px-2",
    style: _normalizeStyle({ 'background-image': `url(${props.data?.image})` })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.withTimer && !props.data.expired && props.data.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", _hoisted_4, _toDisplayString(props.data.title.slice(0, 2)), 1),
              _hoisted_5
            ]),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h1", _hoisted_8, _toDisplayString(props.data.title.slice(3, 5)), 1),
              _hoisted_9
            ]),
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h1", _hoisted_12, _toDisplayString(props.data.title.slice(6, 8)), 1),
              _hoisted_13
            ])
          ]))
        : (_openBlock(), _createElementBlock("h1", _hoisted_14, _toDisplayString(props.data.title), 1)),
      _createElementVNode("p", _hoisted_15, _toDisplayString(props.data.description), 1),
      _createElementVNode("div", _hoisted_16, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data.topicList, (item, index) => {
          return (_openBlock(), _createElementBlock("span", {
            key: index,
            type: "default",
            class: "bg-white px-3 py-2 rounded-xl font-bold text-center"
          }, _toDisplayString(item), 1))
        }), 128))
      ])
    ])
  ], 4))
}
}

})